"use client";

import { useTranslations } from "next-intl";
import { Stack } from "@mui/material";
import { NumberInput, RadioCard } from "@leabankab/component-library";

const DEFAULT_YEAR_OPTIONS = [2, 5, 10, 15] as const;

type Props = {
	label: string;
	valueYears: number;
	onChange: (years: number) => void;
	yearOptions?: readonly number[];
	yearLabel: (years: number) => string;
	min?: number;
	max?: number;
};

export const RepaymentPeriodSelector = ({
	label,
	valueYears,
	onChange,
	yearOptions = DEFAULT_YEAR_OPTIONS,
	yearLabel,
	min = 1,
	max = 15,
}: Props) => {
	const clamp = (years: number) => Math.max(min, Math.min(years, max));
	const dateUnits = useTranslations("units.dates");

	return (
		<Stack spacing={1.5}>
			<NumberInput
				aria-label={label}
				value={valueYears}
				min={min}
				max={max}
				showSteppers={false}
				onValueChange={(next) => onChange(clamp(next ?? min))}
				label={label}
				labelPlacement="outside"
				unit={dateUnits("year")}
			/>

			<RadioCard.Group
				value={String(valueYears)}
				onValueChange={(next) => onChange(clamp(Number(next)))}
				aria-labelledby={label}
				columns={yearOptions.length}
			>
				{yearOptions.map((years) => (
					<RadioCard.Root key={years} value={String(years)} size="sm">
						<RadioCard.Content>
							<RadioCard.Label>
								{yearLabel(years)}
							</RadioCard.Label>
						</RadioCard.Content>
					</RadioCard.Root>
				))}
			</RadioCard.Group>
		</Stack>
	);
};
